"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHexRgb = toHexRgb;
exports.getPageColors = getPageColors;

/** Convert a rgb(...) or rgba(...) string to its hexadecimal representation. */
function toHexRgb(rgbColor) {
  if (!rgbColor || !rgbColor.startsWith('rgb')) {
    return rgbColor;
  } // eslint-disable-next-line prefer-template


  return "#" + rgbColor.replace(/rgba?\((.+)\)/, '$1').split(',').slice(0, 3).map(function (x) {
    return x.trim();
  }).map(function (x) {
    return Number.parseInt(x, 10);
  }).map(function (x) {
    return x.toString(16);
  }).join('');
}
/** Determine foreground and background color from text image. */


function getPageColors(imgData) {
  var colors = {}; // Data is a flat array containing the image pixels as uint8 RGBA values in the range [0, 255]

  for (var i = 0; i < imgData.length - 3; i += 4) {
    var _colors$rgb;

    var r = imgData[i];
    var g = imgData[i + 1];
    var b = imgData[i + 2];
    var rgb = "rgb(" + r + "," + g + "," + b + ")";
    colors[rgb] = ((_colors$rgb = colors[rgb]) !== null && _colors$rgb !== void 0 ? _colors$rgb : 0) + 1;
  } // Really simple algorithm: The most frequent color is always going to be the text color,
  // the next most frequent color is the background. This can and should probably be tweaked
  // with some heuristics in the future (converting to HSL seems worthwhile), but it's good
  // enough for now.
  // FIXME: Testing with a cairo-backed canvas revelead that this approach relies a lot on
  //        the implementations in Firefox and Chrome, i.e. we got lucky. Needs more work
  //        to be more reliable and testable!


  var _Object$entries$sort$ = Object.entries(colors).sort(function (a, b) {
    return b[1] - a[1];
  }).slice(0, 2).map(function (_ref) {
    var k = _ref[0],
        v = _ref[1];
    return k;
  }),
      textColor = _Object$entries$sort$[0],
      bgColor = _Object$entries$sort$[1];

  return {
    textColor: textColor,
    bgColor: bgColor
  };
}